// Types
import type { RouteLocationNormalized, Router } from 'vue-router';
import type { TListingsStore } from '~/misc/listings/store/types';

// Store
import { useListingsStore } from '~/misc/listings/store';

// Services
import { OpportunitiesStoreToQueryResolver } from '~/modules/opportunities/services/store-to-query-resolver';

export const useOpportunitiesStoreToQueryResolver = (router: Router) => {
  const route: RouteLocationNormalized = useRoute();
  const store: TListingsStore = useListingsStore();

  const storeToQueryResolver = new OpportunitiesStoreToQueryResolver(store, router, route);

  // Apply store to query if store updated
  // TODO: Unload store to query handling (consider calculating changed filters only)
  watch(
    () => store,
    () => storeToQueryResolver.process(),
    {
      deep: true,
    }
  );

  // Apply store to query if route has no query params
  watch(
    () => route.path,
    () => {
      if (Object.keys(route.query).length) return;

      storeToQueryResolver.process();
    },
    {
      flush: 'post',
    }
  );
};
